export default class DateTool {
	constructor(){
	}

	public static getDate(currentDate?:string){
        var date:Date = null;
        if ( currentDate === undefined ) {
            date = new Date();
        }else{
            date = new Date(currentDate);
        }
        return date.getFullYear() + '-' + ((date.getMonth()+1)/100).toString().substr(2) + '-' + ((date.getDate())/100).toString().substr(2);
    }

	public static getDateHu(currentDate?:string){
        var date:Date = null;
        if ( currentDate === undefined ) {
            date = new Date();
        }else{
            date = new Date(currentDate);
        }
        return date.getFullYear() + '.' + ((date.getMonth()+1)/100).toString().substr(2) + '.' + ((date.getDate())/100).toString().substr(2);
    }
}
new DateTool();



// WEBPACK FOOTER //
// ./avernus/datetool/source/DateTool.ts